// extracted by mini-css-extract-plugin
export default {"card":"CartCard_card__fXgc9","box":"CartCard_box__CzsDy"};